export default "__VITE_ASSET__DrzK1uyI__"